import { useCallback } from 'react';

import { useAppContext } from '../../../common/ui/app-context';
import { onContextMenuCopyButtonClicked } from '../../../common/utils/events/context-menu-copy-button-clicked';
import { serveSearchPageRelayExp } from '../../../common/utils/experiments';
import { getExtensionData } from '../../../common/utils/relay/get-extension-data';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';
import { usePrimaryProduct } from '../../store/bootstrap/accessors';

/**
 * @returns a callback to fire an event when the result
 * context menu copy button is clicked by the user.
 */
export const useFireContextMenuCopyButtonClicked = () => {
	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();
	const [primaryProduct] = usePrimaryProduct();
	const { queryParams } = useAppContext();

	return useCallback(() => {
		fireAnalyticsEvent(
			onContextMenuCopyButtonClicked({
				commonAttributes: {
					...commonAttributes,
					...(primaryProduct && serveSearchPageRelayExp(primaryProduct, false, queryParams)
						? getExtensionData(commonAttributes.isCQL)
						: {}),
				},
				nonPrivacySafeAttributes,
			}),
		);
	}, [fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes, primaryProduct, queryParams]);
};
